import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import AnswerArea from "components/AnswerArea/AnswerArea.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

// Domains
import Domain1 from "components/Typography/Domain1.jsx";
import Domain2 from "components/Typography/Domain2.jsx";
import Domain3 from "components/Typography/Domain3.jsx";
import Domain4 from "components/Typography/Domain4.jsx";
import Domain5 from "components/Typography/Domain5.jsx";
import Domain6 from "components/Typography/Domain6.jsx";
import Domain7 from "components/Typography/Domain7.jsx";


import DomainCircleScore from "components/DomainCircleScore/DomainCircleScore.jsx";

import capExResWelcomeStyle from "assets/jss/material-kit-pro-react/views/capabilityExplorerResultsPageSections/capExResWelcomeStyle.jsx";

class CapExResDetailsSection extends React.Component {

  getScore = domain => {
    const resultDomain = this.props.results.find(result => {
      if (result.domain === domain) return true;
    });
    if (resultDomain) {
      return resultDomain.score;
    } else {
      return 0;
    }
    // return resu?ltDomain.score;
  };

  createAnswerBlock = answer => {
    return (
      <div key={answer.question.id}>
        <AnswerArea
          key={answer.question.id}
          id={answer.question.id}
          domain={answer.question.domain}
          question={answer.question.name}
          answer={answer.answer}
          score={answer.question.score}
        />
        {/* <CustomLinearProgress
          variant="determinate"
          color={answer.question.domain}
          thickness={1}
          value={(answer.question.score * 100) / 4}
        /> */}
      </div>
    );
  };

  // getIconDomain = domain => {
  //   return
  // }

  // getTitleDomain = domain => {
  //   return
  // }

  // getDesciptionDomain = domain => {
  //   return
  // }

  // createDomainBlock = domain => {
  //   return (
  //     <Card plain blog className={classes.card}>
  //       <GridContainer>
  //         <GridItem xs={12} sm={4} md={2}>
  //           <CardHeader image plain>
  //             <DomainCircleScore
  //               key={domain}
  //               id={domain}
  //               domain={domain}
  //               value={this.getScore(domain)}
  //             />
  //           </CardHeader>
  //         </GridItem>
  //         <GridItem xs={12} sm={4} md={8}>
  //           <DomainDesign>
  //             <h6 className={classes.cardCategory}>{D1Text.title}</h6>
  //             <p>{D1Text.desc}</p>
  //           </DomainDesign>
  //         </GridItem>
  //       </GridContainer>
  //     </Card>
  //   )
  // }

  render() {
    const { classes } = this.props;
    let answersItemD1 = [];
    let answersItemD2 = [];
    let answersItemD3 = [];
    let answersItemD4 = [];
    let answersItemD5 = [];
    let answersItemD6 = [];
    let answersItemD7 = [];

    const D1Text = {
      title: "Designing Learning and Teaching",
      desc: "Teaching quality in the design, delivery and evaluation including pedagogical approaches and cohort analysis"
    };

    const D2Text = {
      title: "Facilitating and Delivering Learning and Teaching",
      desc: "Designing curriculum including strategies for organising content, learning pathways and activities that maximise retention and student success"
    };

    const D3Text = {
      title: "Transforming Assessment",
      desc: "Transforming assessment to maximise student learning from both the process and products of assessment"
    };

    const D4Text = {
      title: "Optimising Digital Technologies for Learning and Teaching",
      desc: "Using digital content, tools and technologies to improve student outcomes and increase teacher impact, including with productivity and collaboration systems"
    };

    const D5Text = {
      title: "Transforming the Broader Student Experience",
      desc: "A culture that promotes the equitable participation, retention and progression of all students to, through and beyond the learning/classroom"
    };

    const D6Text = {
      title: "Industry and Academic Collaboration & Currency",
      desc: "Ongoing engagement in the profession that ensures currency of knowledge and practice"
    };

    const D7Text = {
      title: "Innovating in Learning and Teaching",
      desc: "Changing the way we teach and our students learn to improve student outcomes"
    };

    let answerItems = this.props.answers.map(answer => {
      switch (answer.question.domain) {
        case "D1":
          answersItemD1.push(this.createAnswerBlock(answer));
          break;
        case "D2":
          answersItemD2.push(this.createAnswerBlock(answer));
          break;
        case "D3":
          answersItemD3.push(this.createAnswerBlock(answer));
          break;
        case "D4":
          answersItemD4.push(this.createAnswerBlock(answer));
          break;
        case "D5":
          answersItemD5.push(this.createAnswerBlock(answer));
          break;
        case "D6":
          answersItemD6.push(this.createAnswerBlock(answer));
          break;
        case "D7":
          answersItemD7.push(this.createAnswerBlock(answer));
          break;
      }
    });

    return (
      <div className={classes.section}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <h2 className={classes.title}>Your Answers</h2>
            {/* DOMAIN 1 - START */}
            <Card plain blog className={classes.card}>
              <GridContainer>
                <GridItem xs={12} sm={4} md={2}>
                  <CardHeader image plain>
                    <DomainCircleScore
                      key={"D1"}
                      id={"D1"}
                      domain={"D1"}
                      value={this.getScore("D1")}
                    />
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={8} md={10}>
                  <Domain1>{D1Text.title}</Domain1>
                  <p>{D1Text.desc}</p>
                </GridItem>
              </GridContainer>
            </Card>
            {answersItemD1}
            {/* DOMAIN 1 - END */}

            {/* DOMAIN 2 - START */}
            <Card plain blog className={classes.card}>
              <GridContainer>
                <GridItem xs={12} sm={4} md={2}>
                  <CardHeader image plain>
                    <DomainCircleScore
                      key={"D2"}
                      id={"D2"}
                      domain={"D2"}
                      value={this.getScore("D2")}
                    />
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={8} md={10}>
                  <Domain2>{D2Text.title}</Domain2>
                  <p>{D2Text.desc}</p>
                </GridItem>
              </GridContainer>
            </Card>
            {answersItemD2}
            {/* DOMAIN 2 - END */}

            {/* DOMAIN 3 - START */}
            <Card plain blog className={classes.card}>
              <GridContainer>
                <GridItem xs={12} sm={4} md={2}>
                  <CardHeader image plain>
                    <DomainCircleScore
                      key={"D3"}
                      id={"D3"}
                      domain={"D3"}
                      value={this.getScore("D3")}
                    />
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={8} md={10}>
                  <Domain3>{D3Text.title}</Domain3>
                  <p>{D3Text.desc}</p>
                </GridItem>
              </GridContainer>
            </Card>
            {answersItemD3}
            {/* DOMAIN 3 - END */}

            {/* DOMAIN 4 - START */}
            <Card plain blog className={classes.card}>
              <GridContainer>
                <GridItem xs={12} sm={4} md={2}>
                  <CardHeader image plain>
                    <DomainCircleScore
                      key={"D4"}
                      id={"D4"}
                      domain={"D4"}
                      value={this.getScore("D4")}
                    />
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={8} md={10}>
                  <Domain4>{D4Text.title}</Domain4>
                  <p>{D4Text.desc}</p>
                </GridItem>
              </GridContainer>
            </Card>
            {answersItemD4}
            {/* DOMAIN 4 - END */}

            {/* DOMAIN 5 - START */}
            <Card plain blog className={classes.card}>
              <GridContainer>
                <GridItem xs={12} sm={4} md={2}>
                  <CardHeader image plain>
                    <DomainCircleScore
                      key={"D5"}
                      id={"D5"}
                      domain={"D5"}
                      value={this.getScore("D5")}
                    />
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={8} md={10}>
                  <Domain5>{D5Text.title}</Domain5>
                  <p>{D5Text.desc}</p>
                </GridItem>
              </GridContainer>
            </Card>
            {answersItemD5}
            {/* DOMAIN 5 - END */}

            {/* DOMAIN 6 - START */}
            <Card plain blog className={classes.card}>
              <GridContainer>
                <GridItem xs={12} sm={4} md={2}>
                  <CardHeader image plain>
                    <DomainCircleScore
                      key={"D6"}
                      id={"D6"}
                      domain={"D6"}
                      value={this.getScore("D6")}
                    />
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={8} md={10}>
                  <Domain6>{D6Text.title}</Domain6>
                  <p>{D6Text.desc}</p>
                </GridItem>
              </GridContainer>
            </Card>
            {answersItemD6}
            {/* DOMAIN 6 - END */}

            {/* DOMAIN 7 - START */}
            <Card plain blog className={classes.card}>
              <GridContainer>
                <GridItem xs={12} sm={4} md={2}>
                  <CardHeader image plain>
                    <DomainCircleScore
                      key={"D7"}
                      id={"D7"}
                      domain={"D7"}
                      value={this.getScore("D7")}
                    />
                  </CardHeader>
                </GridItem>
                <GridItem xs={12} sm={8} md={10}>
                  <Domain7>{D7Text.title}</Domain7>
                  <p>{D7Text.desc}</p>
                </GridItem>
              </GridContainer>
            </Card>
            {answersItemD7}
            {/* DOMAIN 7 - END */}
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(capExResWelcomeStyle)(CapExResDetailsSection);
